import { z } from 'zod';
import { ATTACHMENT_ALLOWED_MIME_TYPES, ATTACHMENT_MAX_SIZE_BYTES } from '../constants.js';
/**
 * FLOOR_PLAN_BG — подложка-фото для обводки в редакторе планировок; NEED_OPTION_PHOTO — своё фото
 * товара в подборке. Ни то, ни другое не входит ни в «Сметы», ни в «Фото».
 */
export const attachmentKindEnum = z.enum(['ESTIMATE', 'PHOTO', 'RECEIPT', 'DOCUMENT', 'FLOOR_PLAN_BG', 'NEED_OPTION_PHOTO']);
export const attachmentStatusEnum = z.enum(['PENDING', 'READY']);
/** Тот же список, что проверяет сервер: клиент не должен иметь своей копии. */
export const attachmentMimeSchema = z.enum(ATTACHMENT_ALLOWED_MIME_TYPES);
export const createAttachmentUploadSchema = z.object({
    kind: attachmentKindEnum.default('DOCUMENT'),
    /** Отсутствует/undefined = вложение уровня проекта (смета, галерея, staged-чек). */
    expenseId: z.string().optional(),
    fileName: z.string().min(1).max(255),
    mimeType: attachmentMimeSchema,
    sizeBytes: z.number().int().positive().max(ATTACHMENT_MAX_SIZE_BYTES),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
});
export const confirmAttachmentsSchema = z.object({
    ids: z.array(z.string()).min(1).max(20),
});
export const attachToExpenseSchema = z.object({
    ids: z.array(z.string()).min(1).max(20),
    expenseId: z.string(),
});
export const attachmentUploadTicketSchema = z.object({
    attachmentId: z.string(),
    uploadUrl: z.string().url(),
    headers: z.record(z.string()),
    expiresIn: z.number(),
});
export const attachmentSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    expenseId: z.string().nullable(),
    kind: attachmentKindEnum,
    fileName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    createdAt: z.string(),
    /** Предподписанная ссылка. Срок жизни ограничен — не кэшировать надолго. */
    url: z.string().url(),
    urlExpiresAt: z.string(),
});
export const attachmentListSchema = z.array(attachmentSchema);
//# sourceMappingURL=attachment.js.map